export const receipt_types = [
    {
        uid: 'sale',
        name: '销售业务收款单'
    }, 
    {
        uid: 'other',
        name:'其他业务收款单'
    },
    {
        uid: 'sale_refund',
        name: '销售业务退款单'
    },
    {
        uid: 'other_refund',
        name: '其他业务退款单'
    },
]
export const receipt_accrual_types = [
    {
        uid: 'other',
        name:'其他应收单'
    }
]
export const receivable_type = [
    {
        uid: 'other',
        name:'其他应收单'
    }
]
export const unit_types = [
    {
        uid: 'Client',
        name: '客户'
    },
    {
        uid: 'PayeeCompany',
        name: '供应商'
    },
    {
        uid: 'Customer',
        name: '员工'
    },
    {
        uid: 'Company',
        name: '组织机构'
    }
]

export const search_types = [
    {
        uid: 'all',
        name: '全部'
    },
    {
        uid: 'pending',
        name: '待我处理'
    },
    {
        uid: 'mine',
        name: '我提交的'
    }
]

export const flow_status_list = [
    {
        name: '进行中',
        value: false
    },
    {
        name: '通过/完成',
        value: true
    }
]

